import { makeObservable, observable } from 'mobx';

export class TableSportsState {
    @observable private open: boolean = true;

    public constructor() {
        makeObservable(this);
    }

    public get isOpen(): boolean {
        return this.open;
    }

    public handleClick = (): void => {
        this.open = !this.open;
    };
}
